export const locales = ['en', 'de', 'fr'] as const

export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'en'

export const localeLabels: Record<Locale, string> = {
    en: 'EN',
    de: 'DE',
    fr: 'FR'
}

/** Native language names, identical in every locale (proper nouns). */
export const localeNames: Record<Locale, string> = {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français'
}
